<p *pcpHeaderInject="headerItemLocation.end" class="mat-body">
  <span i18n>Already registered?</span>
  <a *ngIf="standAlone" routerLink="/login" i18n>  Log in.</a>
  <a *ngIf="!standAlone" (click)="loginRequested.emit()" i18n>Log in.</a>
</p>
<div class="login mat-typography noselect" fxFill>
  <mat-card
    appearance="outlined"
    fxLayout="column"
    fxFlex="480px"
    fxFlex.xs="100%"
    fxLayoutAlign="stretch"
    class="mat-elevation-z13"
  >
    <mat-toolbar color="primary" class="mat-elevation-z3">
      <mat-icon aria-hidden="true">person_add</mat-icon>
      <span i18n>Register</span>
    </mat-toolbar>
    <mat-card-content>
      <form name="form" [formGroup]="registerForm" (ngSubmit)="register()">
        <mat-stepper #stepper [linear]="true">
          <mat-step
            i18n-label
            label="Verify Your Email"
            [stepControl]="$any(verifyGroup)"
          >
            <div
              formGroupName="verifyGroup"
              fxLayout="column"
              fxLayoutAlign="space-evenly stretch"
            >
              <mat-form-field>
                <input
                  matInput
                  i18n-placeholder
                  placeholder="First Name"
                  formControlName="firstName"
                />
                <mat-error *ngIf="!firstName?.valid" i18n
                  >Please enter your first name.</mat-error
                >
              </mat-form-field>
              <mat-form-field>
                <input
                  matInput
                  i18n-placeholder
                  placeholder="Last Name"
                  formControlName="lastName"
                />
                <mat-error *ngIf="!lastName?.valid" i18n
                  >Please enter your last name.</mat-error
                >
              </mat-form-field>
              <mat-form-field>
                <input
                  type="email"
                  matInput
                  i18n-placeholder
                  placeholder="Email"
                  formControlName="email"
                />
                <mat-error *ngIf="!!email?.errors?.required" i18n
                  >Please enter your email.</mat-error
                >
                <mat-error *ngIf="!!email?.errors?.invalidEmail" i18n
                  >Please enter a valid email.</mat-error
                >
                <mat-error *ngIf="!!email?.errors?.emailAlreadyExists" i18n
                  >This email is already registered. Please
                  <a routerLink="/login">login</a> or
                  <a routerLink="/reset">reset your password</a></mat-error
                >
              </mat-form-field>
              <div
                pcpRecaptcha
                [key]="recaptchaSiteKey"
                formControlName="captcha"
              ></div>
              <mat-error *ngIf="!!captcha?.errors?.required" i18n
                >Please identify yourself as human.</mat-error
              >
              <mat-error *ngIf="!!captcha?.errors?.invalidCaptcha" i18n
                >Verification failed. Please try again.</mat-error
              >
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
              >
                <button
                  type="button"
                  mat-button
                  [disabled]="!verifyGroup?.valid"
                  (click)="verifyEmail()"
                >
                  Verify Email
                </button>
                <mat-spinner diameter="32" *ngIf="verifyingEmail"></mat-spinner>
              </div>
            </div>
          </mat-step>
          <mat-step
            i18n-label
            label="Enter Registration Details"
            fxLayout="column"
            fxLayoutAlign="space-evenly stretch"
            [stepControl]="registerForm"
          >
            <mat-form-field>
              <input
                matInput
                i18n-placeholder
                placeholder="Email code"
                formControlName="code"
              />
              <mat-error *ngIf="!!code?.errors?.required" i18n
                >Please enter the code you received via email.</mat-error
              >
              <mat-error *ngIf="!!code?.errors?.invalidCode" i18n
                >The code you have entered is invalid. Please verify your email
                again.</mat-error
              >
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                i18n-placeholder
                placeholder="Phone Number (Optional)"
                formControlName="phoneNumber"
              />
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                i18n-placeholder
                placeholder="Organization Name (Optional)"
                formControlName="organizationName"
              />
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                i18n-placeholder
                placeholder="Password"
                type="password"
                formControlName="password"
              />
              <mat-icon class="form-icon" matSuffix>vpn_key</mat-icon>
              <mat-error
                *ngIf="
                  !!password?.errors?.minLength ||
                  !!password?.errors?.passwordTooShort
                "
                i18n
                >The password must contain atleast 6 characters.</mat-error
              >
              <mat-error *ngIf="!!password?.errors?.required" i18n
                >Please provide a password.</mat-error
              >
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                i18n-placeholder
                placeholder="Confirm Password"
                type="password"
                formControlName="confirmPassword"
              />
              <mat-icon class="form-icon" matSuffix>vpn_key</mat-icon>
              <mat-error *ngIf="!!confirmPassword?.errors?.required" i18n
                >Please confirm your password.</mat-error
              >
              <mat-error *ngIf="!!registerForm.errors?.passwordMatch" i18n
                >Passwords do not match. Please type your password
                again.</mat-error
              >
            </mat-form-field>
          </mat-step>
          <mat-step
            i18n-label
            label="Register"
            fxLayout="column"
            fxLayoutAlign="space-evenly stretch"
          >
            <mat-card-actions fxLayout="row" fxLayoutAlign="center center">
              <button
                type="submit"
                mat-raised-button
                color="primary"
                [disabled]="registering || !registerForm.valid"
              >
                Complete Registration
              </button>
              <mat-spinner
                class="inline-spinner"
                diameter="32"
                *ngIf="registering"
              ></mat-spinner>
            </mat-card-actions>
          </mat-step>
        </mat-stepper>
      </form>
    </mat-card-content>
  </mat-card>
</div>
